import { render, staticRenderFns } from "./ModalUpdateOrCreateFolder.vue?vue&type=template&id=533645c1"
import script from "./ModalUpdateOrCreateFolder.vue?vue&type=script&lang=js"
export * from "./ModalUpdateOrCreateFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports